import { useSearchParams } from 'react-router-dom';

export const useStageParam = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const stageParam = searchParams.get('stage');

  const deleteStageParam = (options?: { replace?: boolean }) => {
    const next = new URLSearchParams(searchParams);
    next.delete('stage');
    setSearchParams(next, { replace: options?.replace });
  };

  const setStageParam = (stageId: string, options?: { replace?: boolean }) => {
    const next = new URLSearchParams(searchParams);
    next.set('stage', stageId);
    setSearchParams(next, { replace: options?.replace });
  };

  return { stageParam, deleteStageParam, setStageParam };
};
